module.exports = __webpack_public_path__ + "img/apk_store.038d656.png";